export default __webpack_public_path__ + "static/media/plus-rond.83afec9c.svg";